import React, { useEffect, useState } from "react";
import { project, projectGroup } from "../../../system/types/project/project";
import { initialProject } from "../../../system/initial/project";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/reducers";
import { dispatch } from "../../../App";
import { actions } from "../../../redux";
import { TextInput } from "../../FormElements/TextInput";
import { TextAreaInput } from "../../FormElements/TextareaInput";
import { formatKey } from "../../../system/helper/formatKey";
import { ProjectApi } from "../../../system/api/ProjectApi";
import { useTranslations } from "../../../hooks/useTranslations";

const EditGroup = () => {

    const { t } = useTranslations();

    const [sessionToken, setSessionToken] = useState<string>('');
    const [sessionEmail, setSessionEmail] = useState<string>('');
    const [projectData, setProjectData] = useState<project>(initialProject);

    const [projectId, setProjectId] = useState<string>('');
    const [commandId, setCommandId] = useState<string>('');
    const [allowDelete, setAllowDelete] = useState<boolean>(false);

    const [editGroup, setEditGroup] = useState<projectGroup>({
        uniqueId: '',
        key: '',
        name: '',
        description: '',
        groups: [],
        entries: [],
    });

    const [groupName, setGroupName] = useState<string>('');
    const [groupKey, setGroupKey] = useState<string>('');
    const [groupDescription, setGroupDescription] = useState<string>('');

    useSelector((state: RootState) => {

        if (state.activeUser.activeUserToken !== sessionToken) {
            setSessionToken(state.activeUser.activeUserToken);
        }

        if (state.activeUser.activeUserEmail !== sessionEmail) {
            setSessionEmail(state.activeUser.activeUserEmail);
        }

        if (state.project.projectId !== projectId) {
            setProjectId(state.project.projectId);
        }
        if (state.project.projectData !== projectData) {
            setProjectData(state.project.projectData);
        }
        if (state.project.pageCommandId !== commandId) {
            setCommandId(state.project.pageCommandId);
        }

    });


    const save = async () => {
        const newGroup = {
            ...editGroup,
            name: groupName,
            key: groupKey,
            description: groupDescription,
        };

        const api = new ProjectApi(sessionToken, sessionEmail);

        const result = await api.saveGroupData(projectId, newGroup);

        if (result._id) {
            dispatch(actions.project.setData(result))
            dispatch(actions.project.setPageCommand(''));
        }
    };

    const deleteEntry = async () => {

        const userConfirmed = window.confirm('soll die Gruppe gelöscht werden?');
        
        if (!userConfirmed){
            return;
        }

        const api = new ProjectApi(sessionToken, sessionEmail);

        const result = await api.deleteGroupData(projectId, editGroup.uniqueId);

        if (result._id) {
            dispatch(actions.project.setData(result))
            dispatch(actions.project.setPageCommand(''));
        }
    };

    const cancel = () => {
        dispatch(actions.project.setPageCommand(''));
    };

    const changeGroupName = (input: string) => {
        setGroupName(input);
        if (commandId === '') {
            changeGroupKey(input);
        }
    };

    const changeGroupKey = (input: string) => {
        const formatedKey = formatKey(input);
        setGroupKey(formatedKey);
    };

    const changeGroupDescription = (input: string) => {
        setGroupDescription(input);
    };

    useEffect(() => {

        projectData.groups.forEach((group) => {
            if (group.uniqueId === commandId) {
                setEditGroup(group);
                return;
            }
        });

    }, [projectData]);

    useEffect(()=>{
        setGroupName(editGroup.name);
        setGroupKey(editGroup.key);
        setGroupDescription(editGroup.description);

        if (editGroup.uniqueId !== '' && editGroup.entries.length === 0) {
            setAllowDelete(true);
            return;
        }

        setAllowDelete(false);

    },[editGroup]);

    return (
        <div className="container-float px-3 py-3">
            <div className="row mb-3 align-items-center">
                <div className="col"><h2>{editGroup.name === '' ? 'Gruppe hinzufügen' : editGroup.name} &nbsp;</h2></div>
                <div className="col-auto"><button onClick={save} className="btn btn-outline-success">{t('common.save')}</button></div>
                {allowDelete ?
                    <div className="col-auto"><button onClick={deleteEntry} className="btn btn-outline-danger">{t('common.delete')}</button></div>
                    : null}
                <div className="col-auto"><button onClick={cancel} className="btn btn-outline-danger">{t('common.cancel')}</button></div>
            </div>
            <div className="row mb-3">
                <div className="col">
                    <TextInput
                        name="groupName"
                        value={groupName}
                        label={t('projects.groupname')}
                        onChange={changeGroupName}></TextInput>
                </div>
            </div>
            {commandId === '' ?
                <div className="row mb-3">
                    <div className="col">
                        <TextInput
                            name="groupKey"
                            value={groupKey}
                            label={t('projects.groupkey')}
                            onChange={changeGroupKey}></TextInput>
                    </div>
                </div>
                :
                <div className="row mb-3">
                    <div className="col-3"><strong>{t('projects.groupkey')}:</strong></div>
                    <div className="col-auto">{groupKey}</div>
                </div>
            }
            <div className="row mb-3">
                <div className="col">
                    <TextAreaInput
                        name="projectDescription"
                        value={groupDescription}
                        label={t('projects.groupdescription')}
                        onChange={changeGroupDescription}></TextAreaInput>
                </div>
            </div>

        </div>
    );
};

export { EditGroup };
